import React from 'react';
import './PhotoGallery.css';

import eventImg1 from '../assets/gallery/1.png';
import eventImg2 from '../assets/gallery/2.png';
import eventImg3 from '../assets/gallery/3.png';
import eventImg4 from '../assets/gallery/4.png';
import eventImg5 from '../assets/gallery/5.png';
import eventImg6 from '../assets/gallery/6.png';
import eventImg7 from '../assets/gallery/7.png';
import eventImg8 from '../assets/gallery/8.png';
import eventImg9 from '../assets/gallery/9.png';
import eventImg10 from '../assets/gallery/10.png';

const images = [eventImg1, eventImg2, eventImg5, eventImg7, eventImg3, eventImg6, eventImg4, eventImg8, eventImg9, eventImg10];

const PhotoGallery = () => {
    return (
        <div className="gallery-page-container">
            <h1 className="gallery-page-title">Our Gallery</h1>
            <div className="gallery-grid-main">
                {images.map((src, index) => (
                    <div className="gallery-item-card" key={index}>
                        <img src={src} alt={`Event Photo ${index + 1}`} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PhotoGallery;